var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaterialSave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "1650 243 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1661.333 248.667h-9.444v-3.778h9.444m-2.833 13.222a2.83 2.83 0 0 1-2.833-2.833 2.83 2.83 0 0 1 2.833-2.834 2.83 2.83 0 0 1 2.833 2.834 2.83 2.83 0 0 1-2.833 2.833Zm4.722-15.111h-11.333c-1.048 0-1.889.85-1.889 1.889v13.222c0 1.039.84 1.889 1.889 1.889h13.222c1.039 0 1.889-.85 1.889-1.889v-11.333l-3.778-3.778Z",
    fill: "#603f3f",
    fillRule: "evenodd",
    "data-name": "material-save"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSave);
export default __webpack_public_path__ + "static/media/material-save.9a709cf9b6b3f4e7552e5635984c57ea.svg";
export { ForwardRef as ReactComponent };